import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  gap: 20px;
`

export const FilterContainer = styled(Container)`
  flex-direction: row;
  width: 680px;
  height: auto;
  gap: 10px;
  padding-top: 0px;
  margin-bottom: 20px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  gap: 5px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`

export const LinkButton = styled(Link)`
  width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  background-color: #252525;
  color: #FFFFFF;
  font-size: 14px;
  padding: 8px 20px;
  border-radius: 15px;
  text-decoration: none;
  gap: 8px;

  &:hover {
    background-color: #121212;
    color: #FFFFFF;
  }
`
